import Vue from 'vue'

export const historical = {
    namespaced: true,
    state: {
        events: []
    },
    actions: {
        addEvent({ commit }, event) {
            commit('addEvent', event);
        },
        resetEvents({ commit }) {
            commit('resetEvents');
        }
    },
    mutations: {
        addEvent(state, event) {
            Vue.set(state, 'events', [...state.events, event]);
        },
        resetEvents(state) {
            Vue.set(state, 'events', []);
        }
    },
    getters: {
        getEvents: state => state.events
    }
}